import React from 'react'
import Layout from '../components/layout'
import styled from 'styled-components'

import Img4A from '../assets/4A.jpg'


const Div = styled.div`

    background: #f7f8fa;


    .rrhh-container {
        max-width: 1100px;
        margin: 0 auto;
        padding: 60px 25px 80px;
    }


    /* ==============================
       HEADER
    ============================== */

    .rrhh-header {
        text-align: center;
        margin-bottom: 45px;
    }

    .rrhh-eyebrow {
        display: block;

        margin-bottom: 8px;

        color: #E85A20;

        font-size: 12px;
        font-weight: 700;

        letter-spacing: 3px;
        text-transform: uppercase;
    }

    .rrhh-header h2 {
        margin: 0;

        color: #102B50;

        font-size: 40px;
        font-weight: 700;
    }

    .rrhh-line {
        width: 50px;
        height: 4px;

        margin: 15px auto;

        background: #E85A20;

        border-radius: 5px;
    }

    .rrhh-header p {
        max-width: 800px;

        margin: 0 auto;

        color: #526274;

        font-size: 16px;
        line-height: 1.7;
    }


    /* ==============================
       BLOQUE INTRODUCTORIO
    ============================== */

    .rrhh-intro {
        display: grid;
        grid-template-columns: 1fr 1fr;

        gap: 60px;

        align-items: center;

        margin-bottom: 55px;
    }

    .rrhh-intro h3 {
        margin-bottom: 20px;

        color: #102B50;

        font-size: 28px;
        line-height: 1.3;
    }

    .rrhh-intro h3 span {
        color: #E85A20;
    }

    .rrhh-intro p {
        color: #526274;

        font-size: 15px;
        line-height: 1.8;
    }


    /* ==============================
       DESTACADOS
    ============================== */

    .rrhh-features {
        display: grid;
        grid-template-columns: repeat(3, 1fr);

        gap: 20px;

        margin-bottom: 55px;
    }

    .rrhh-feature {
        padding: 28px 25px;

        background: #ffffff;

        border: 1px solid #e5e9ed;

        border-radius: 8px;

        box-shadow: 0 5px 18px rgba(20, 40, 60, 0.05);

        text-align: center;

        transition: all .2s ease;
    }

    .rrhh-feature:hover {
        transform: translateY(-3px);

        box-shadow: 0 9px 25px rgba(20, 40, 60, 0.08);
    }

    .rrhh-feature-icon {
        width: 48px;
        height: 48px;

        display: flex;
        align-items: center;
        justify-content: center;

        margin: 0 auto 15px;

        border-radius: 50%;

        background: #fff1eb;

        color: #E85A20;

        font-size: 20px;
    }

    .rrhh-feature h4 {
        margin-bottom: 10px;

        color: #102B50;

        font-size: 18px;
    }

    .rrhh-feature p {
        margin: 0;

        color: #687586;

        font-size: 13px;
        line-height: 1.6;
    }


    /* ==============================
       IMAGEN
    ============================== */

    .rrhh-image {
        width: 100%;
        height: 420px;

        display: block;

        object-fit: cover;

        border-radius: 8px;

        box-shadow: 0 8px 25px rgba(20, 40, 60, 0.10);

        margin-bottom: 55px;
    }


    /* ==============================
       CTA
    ============================== */

    .rrhh-cta {
        padding: 45px 30px;

        background: #102B50;

        border-radius: 8px;

        text-align: center;
    }

    .rrhh-cta h3 {
        margin-bottom: 12px;

        color: #ffffff;

        font-size: 28px;
    }

    .rrhh-cta p {
        max-width: 650px;

        margin: 0 auto 25px;

        color: rgba(255,255,255,.85);

        font-size: 15px;
        line-height: 1.6;
    }

    .rrhh-button {
        display: inline-block;

        padding: 11px 25px;

        background: #E85A20;

        border-radius: 5px;

        color: #ffffff;

        font-size: 14px;
        font-weight: 600;

        text-decoration: none;

        transition: all .2s ease;
    }

    .rrhh-button:hover {
        background: #d94f19;

        color: #ffffff;

        text-decoration: none;

        transform: translateY(-1px);
    }


    /* ==============================
       MOBILE
    ============================== */

    @media screen and (max-width: 768px) {

        .rrhh-container {
            padding: 45px 18px 60px;
        }

        .rrhh-header h2 {
            font-size: 32px;
        }

        .rrhh-intro {
            grid-template-columns: 1fr;

            gap: 20px;
        }

        .rrhh-features {
            grid-template-columns: 1fr;
        }

        .rrhh-image {
            height: 280px;
        }

        .rrhh-cta {
            padding: 35px 20px;
        }

    }

`


export default function RRHH() {

    return (

        <Layout>

            <Div>

                <div className="rrhh-container">


                    {/* ==============================
                        HEADER
                    ============================== */}

                    <div className="rrhh-header">

                        <span className="rrhh-eyebrow">
                            Personas y desarrollo
                        </span>

                        <h2>
                            Recursos Humanos
                        </h2>

                        <div className="rrhh-line"></div>

                        <p>
                            En Edificar Seguros creemos en el desarrollo
                            de las personas que forman parte de nuestra
                            compañía.
                        </p>

                    </div>


                    {/* ==============================
                        INTRO
                    ============================== */}

                    <div className="rrhh-intro">

                        <div>

                            <h3>
                                Crecer juntos,
                                <br />
                                <span>hacer la diferencia.</span>
                            </h3>

                            <p>
                                Edificar Seguros es una compañía sumamente
                                interesada en el desarrollo profesional de
                                sus recursos humanos, brindando
                                capacitaciones, beneficios y puestos acorde
                                a las capacidades particulares de cada
                                integrante.
                            </p>

                            <p>
                                Buscamos personas que quieran formar parte
                                de nuestro equipo de trabajo, aportando
                                creatividad y profesionalismo.
                            </p>

                        </div>

                        <div>

                            <img
                                className="rrhh-image"
                                src={Img4A}
                                alt="Equipo de Edificar Seguros"
                            />

                        </div>

                    </div>


                    {/* ==============================
                        VALORES
                    ============================== */}

                    <div className="rrhh-features">


                        <div className="rrhh-feature">

                            <div className="rrhh-feature-icon">
                                ✓
                            </div>

                            <h4>
                                Desarrollo
                            </h4>

                            <p>
                                Promovemos el crecimiento profesional
                                y el desarrollo de las capacidades
                                de cada integrante.
                            </p>

                        </div>


                        <div className="rrhh-feature">

                            <div className="rrhh-feature-icon">
                                +
                            </div>

                            <h4>
                                Capacitación
                            </h4>

                            <p>
                                Apostamos a la formación y a la
                                incorporación constante de conocimientos.
                            </p>

                        </div>


                        <div className="rrhh-feature">

                            <div className="rrhh-feature-icon">
                                ★
                            </div>

                            <h4>
                                Profesionalismo
                            </h4>

                            <p>
                                Buscamos personas comprometidas que
                                aporten creatividad y profesionalismo.
                            </p>

                        </div>


                    </div>


                    {/* ==============================
                        CTA
                    ============================== */}

                    <div className="rrhh-cta">

                        <h3>
                            ¿Querés formar parte de nuestro equipo?
                        </h3>

                        <p>
                            Si estás interesado en desarrollar tu carrera
                            profesional junto a nosotros, podés enviarnos
                            tu CV.
                        </p>

                        <a
                            href="mailto:info@edificarseguros.com.ar?subject=Postulación%20laboral"
                            className="rrhh-button"
                        >
                            Enviar CV
                        </a>

                    </div>


                </div>

            </Div>

        </Layout>

    )

}


// import React from 'react'
// import Layout from '../components/layout'
// import styled from 'styled-components'

// import Img4A from '../assets/4A.jpg'

// const Div = styled.div`

//     .img4A {
//         width: 100%;
//         height: 400px;
//         object-fit: cover;
//     }

// `

// export default function RRHH() {

//     return(
//         <Layout>
//             <Div className="container-xl p-0 ">

//                 <div className="px-lg-0 px-2 text-lg-left text-center">
                        
//                     <h3 className="pt-3 pl-3 text-company"> <b>Recursos Humanos</b> </h3>
//                     <p className="pl-3">Edificar Seguros es una compañía sumamente interesada en el desarrollo profesional de sus recursos humanos brindando capacitaciones, beneficios y puestos acorde a las capacidades particulares de cada integrante.</p>
//                     <p className="pl-3">Buscamos personas que quieran formar parte de nuestro equipo de trabajo aportado creatividad y profesionalismo</p>

//                 </div>
                
//                 <img className="img4A mt-4" src={Img4A} alt=""/>

//             </Div>
//         </Layout>

//     )

// }